import {Customization} from '@eduvision/toolkit';
import {default as CustomContentDetailView} from '../views/ContentDetailView';

export const ContentDetailView: Customization['ContentDetailView'] = {
  component: CustomContentDetailView
};